import { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getNodesFromStops } from '../helpers';

const StopsInLine = ({ stops, activeStop, setActiveStop }) => {
  const nodes = useMemo(() => getNodesFromStops(stops), [stops]);

  return (
    <div className="ps-2 pb-4 timetable__stops-container">
      <div className="timetable__stops-in-line">
        <div className="d-flex justify-content-center">
          {nodes.map(({ id, name, type, duration }) =>
            type === 'stop' ? (
              <div
                key={id}
                className="timetable__one-stop position-relative"
                onClick={() => {
                  setActiveStop(name);
                }}
              >
                <div
                  className={classnames('timetable__stop-point', {
                    'timetable__stop-point--active': name === activeStop,
                  })}
                />
                <div className="timetable__stop-name position-absolute bottom-0 start-100 text-x-small fw-bolder text-primary d-flex align-items-center">
                  <div
                    className={classnames('timetable__2-line', {
                      'timetable__2-line--active': name === activeStop,
                    })}
                  >
                    {name}
                  </div>
                </div>
              </div>
            ) : (
              <div
                key={id}
                className="timetable__stop-duration text-nowrap text-xx-small text-primary pt-3 position-relative flex-grow-1 flex-shrink-0"
              >
                <div className="timetable__stop-duration-word position-absolute start-50 top-50">
                  {duration.replace('unknown', '')}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

StopsInLine.propTypes = {
  activeStop: PropTypes.string,
  setActiveStop: PropTypes.func,
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      duration: PropTypes.string,
    })
  ),
};
export default StopsInLine;
